import { observer } from "mobx-react";
import './add-return-guard-to-theme-screen.scss';
import { FONT_COLOR, FONT_VARIANT } from "../../../../components/fonts/font-props";
import useDashboardTranslation from "../../../../dashboard-translation/hooks/dashboard-translation-hook";
import FontHeading4 from "../../../../components/fonts/font-heading4/font-heading4";
import enableStep1 from "../../../../images/onboarding/enable-step-1.svg";
import enableStep2 from "../../../../images/onboarding/enable-step-2.svg";
import enableStep3 from "../../../../images/onboarding/enable-step-3.svg";
import enableStep4 from "../../../../images/onboarding/enable-step-4.svg";
import EnablereturnGuardOnboardingStep from "../enable-return-guard-onboarding-screen/enable-return-guard-onboarding-step/enable-return-guard-onboarding-step";
import addReturnGuard from "../../../../images/onboarding/add-return-guard.gif";
import SetupReturnGuardStore from "../../stores/setup-return-guard-store";
import { IStepComponent } from "../../onboarding-page";
import ReturnGuardNavigationControls from "../return-guard-navigation-controls/return-guard-navigation-controls";
import OnBoardingScreenTitle from "../onboarding-screen-title/onboarding-screen-title";
import OnboardingWizardStickyFooterPortal from "../onboarding-wizard-sticky-footer/onboarding-wizard-sticky-footer-portal";
import { IEnableReturnGuardStep } from "../enable-return-guard-onboarding-screen/enable-return-guard-shopify-extension/enable-return-guard-shopify-extension";

const AddReturnGuardToThemeScreen: React.FC<IStepComponent> = observer((props) => {
    const store = props.store as SetupReturnGuardStore;
    const { getTranslation } = useDashboardTranslation();
    const scope = "dashboard-onboarding";

    const steps: IEnableReturnGuardStep[] = [
        {
           imgsrc:enableStep1,
           text: getTranslation('ADD_RETURN_GUARD_STEP_1', scope), 
        },
        {
            imgsrc:enableStep2,
            text: getTranslation('ADD_RETURN_GUARD_STEP_2', scope), 
         },
         {
            imgsrc:enableStep3,
            text: getTranslation('ADD_RETURN_GUARD_STEP_3', scope), 
         },
         {
            imgsrc:enableStep4,
            text: getTranslation('ADD_RETURN_GUARD_STEP_4', scope), 
         },
    ]

    return (
        <div className="add-return-guard-to-theme-screen">

            <div className="add-return-guard-to-theme-screen-title-wrapper">
                <OnBoardingScreenTitle
                    titleText={getTranslation('ADD_RETURN_GUARD_TO_THEME_TITLE', scope)}
                    descriptionText={getTranslation('ADD_RETURN_GUARD_TO_THEME_SUBTITLE', scope)}
                    maxWidth={563}
                />
            </div>
            <div className="add-return-guard-to-theme-screen-content">
                <div className="add-return-guard-to-theme-screen-text">
                    <FontHeading4 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{getTranslation('ENABLE_STEPS_TITLES', scope)}</FontHeading4>
                    <div className="add-return-guard-to-theme-screen-steps">
                        {steps.map((step, index) => {
                        return <EnablereturnGuardOnboardingStep step={step} key={index} />
                        })}
                    </div>
                </div>
                <img src={addReturnGuard} alt="add return guard" />
            </div>
            <OnboardingWizardStickyFooterPortal>
                <ReturnGuardNavigationControls
                    onBackClick={store.previousStep}
                    onNextClick={store.nextStep}
                    onSetupLaterClick={store.onSetupLaterClick}
                    onSetupClick={store.onSetupClick}
                    setupButtonHref={store.addExtensionUIBlockURL}
                    showContinueButton={store.showContinueButton}
                    isLoading={store.isLoading}
                />
            </OnboardingWizardStickyFooterPortal>
        </div>
    );
 
});

export default AddReturnGuardToThemeScreen;